import { render, staticRenderFns } from "./DeletePackageModal.vue?vue&type=template&id=039074c0"
import script from "./DeletePackageModal.vue?vue&type=script&lang=js"
export * from "./DeletePackageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports